import styled from 'styled-components'
import {Small} from '@modifi/ui'
import {semiDarkGray, seaNavy} from '@modifi/colors'

export const Wrapper = styled.div`
  padding-bottom: 4px;
`

export const FileNameWrapper = styled.div<{toBeDeleted?: boolean; hasHover?: boolean}>`
  display: flex;
  align-items: center;
  color: ${semiDarkGray};
  overflow-x: hidden;
  min-width: 150px;

  ${({toBeDeleted}): string => (toBeDeleted ? 'text-decoration: line-through;' : '')}

  ${({hasHover}): string =>
    hasHover
      ? `
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: ${seaNavy};
    }
  `
      : ''}
`

export const FileName = styled(Small)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: inherit;
  margin-left: 10px;
`
